
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.78 63.4l7.87-4.55L27 54.17l-7.88 4.54zM4.87 70a2.71 2.71 0 003.7 1L15 67.3l-2.71-4.69-6.43 3.73A2.7 2.7 0 004.87 70zm76.35-46.47l-25.69-6.88a2.71 2.71 0 00-1.4 5.23l19.63 5.26L63 33.38l2.7 4.69L76.15 32 71 51.28a2.71 2.71 0 105.23 1.4l6.7-25.12a2.5 2.5 0 00.29-1.39 2.71 2.71 0 00-2-2.64zm.55 3.07h.07zM36.41 55l7.87-4.55-2.7-4.69-7.88 4.51zM51 46.51L58.91 42l-2.71-4.73-7.87 4.55z","fill":"#fff","data-name":"Livello 2"}})])
          )
        }
      }
    